import { a as __assign } from '../../tslib.es6-16156773.js';
import React, { isValidElement } from 'react';
import cn from 'classnames';
import { Checkmark } from '../checkmark/Component.js';

var styles = {"option":"select__option_8mq2q","disabled":"select__disabled_8mq2q","s":"select__s_8mq2q","m":"select__m_8mq2q","l":"select__l_8mq2q","xl":"select__xl_8mq2q","selected":"select__selected_8mq2q","highlighted":"select__highlighted_8mq2q","content":"select__content_8mq2q","textContent":"select__textContent_8mq2q"};
require('./index.css');

var Option = function (_a) {
    var _b, _c;
    var _d = _a.size, size = _d === void 0 ? 's' : _d, className = _a.className, option = _a.option, children = _a.children, selected = _a.selected, highlighted = _a.highlighted, disabled = _a.disabled, _e = _a.Checkmark, Checkmark$1 = _e === void 0 ? Checkmark : _e, innerProps = _a.innerProps, dataTestId = _a.dataTestId;
    var content = children || option.content || option.key;
    return (React.createElement("div", __assign({}, innerProps, { className: cn(styles.option, styles[size], className, (_b = {},
            _b[styles.highlighted] = highlighted,
            _b[styles.selected] = selected,
            _b[styles.disabled] = disabled,
            _b)), "data-test-id": dataTestId }),
        Checkmark$1 && React.createElement(Checkmark$1, { selected: selected }),
        React.createElement("div", { className: cn(styles.content, (_c = {},
                _c[styles.textContent] = !isValidElement(content),
                _c)) }, content)));
};

export { Option };
